import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import WizardError from "../auth/register/WizardError";
import Flex from "../common/Flex";
import ButtonIcon from "../common/ButtonIcon";
import {
  faCheck,
  faSave,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { PreloadState } from "../UI/preloading/PreloadState";
import { updateParking } from "../../helpers/api/parking";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import SupportLink from "../root/support/components/SupportLink";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EditeParking = () => {
  const history = useHistory();
  const { id } = useParams();
  const { state } = useLocation();
  const [data, setData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [edited, setEdited] = useState(false);
  const [available, setAvailable] = useState(true);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange", reValidateMode: "onChange" });

  useEffect(() => {
    let isMounted = true;
    if (!!state?.parking) {
      isMounted && setData(state.parking);
      setTimeout(() => isMounted && setIsLoading(false), 1000);
    } else {
      history.goBack();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [id, state]);

  useEffect(() => {
    register("available");
    setValue("available", available);
    // eslint-disable-next-line
  }, [available]);

  const save = (values) => {
    setSubmitting(true);
    updateParking(id, values)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({
            type: "success",
            title: `Estacionamiento actualizado exitosamente.`,
          });
          history.push("/dashboard/parking");
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <PageHeader
        title="Estacionamiento"
        titleTag="h2"
        description={
          "Si necesitas ayuda comunicanos, nuestra finalidad es ayudar a los usuarios para que puedan resolver inconvenientes."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card tag={Form} onSubmit={handleSubmit(save)}>
        <PreloadState
          loading={isLoading || submitting}
          message={submitting ? "Registrando por favor espere..." : undefined}
        >
          <CardHeader>
            <h5>Actualización de estacionamiento</h5>
          </CardHeader>
          <CardBody className="bg-light">
            <Row form>
              <Col tag={FormGroup}>
                <Label>Acrónimo del estacionamiento</Label>
                <Input
                  onChange={() => !edited && setEdited(true)}
                  defaultValue={data.acronym}
                  type="text"
                  maxLength={3}
                  name="acronym"
                  innerRef={register({
                    required: {
                      value: true,
                      message: "El acrónimo es requerido.",
                    },
                  })}
                />
                {errors.acronym && (
                  <WizardError error={errors.acronym.message} className="fs--1 font-weight-normal d-block"/>
                )}
              </Col>
              <Col tag={FormGroup}>
                <Label>Editar disponibilidad del estacionamiento</Label>
                <Button
                  color="falcon-default"
                  onClick={(e) => {
                    e.preventDefault();
                    !edited && setEdited(true);
                    setAvailable(!available);
                  }}
                  className={classNames("form-control shadow-none", {
                    "border-danger text-danger": !available,
                    "border-success text-success": available,
                  })}
                >
                  {available ? (
                    <FontAwesomeIcon className="mr-2" icon={faCheck} />
                  ) : (
                    <FontAwesomeIcon className="mr-2" icon={faTimes} />
                  )}
                  {available ? "Disponible" : "No disponible"}
                </Button>
              </Col>
            </Row>
            <Row form>
              <Col tag={FormGroup}>
                <Label>Descripción del estacionamiento</Label>
                <Input
                  className={`${
                    errors?.description?.message ? "border-danger" : ""
                  } form-control input-spin-none`}
                  onChange={() => !edited && setEdited(true)}
                  defaultValue={data.description}
                  type="textarea"
                  rows="4"
                  name="description"
                  innerRef={register({
                    required: {
                      value: true,
                      message: "La descripción es requerida.",
                    },
                    minLength: {
                      value: 5,
                      message:
                        "La descripción debe tener al menos 5 carácteres.",
                    },
                  })}
                />
                {errors.description && (
                  <WizardError error={errors.description.message} className="fs--1 font-weight-normal d-block"/>
                )}
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Flex align="center" justify="end">
              <ButtonIcon
                color="light"
                className="px-5 mr-2"
                size="md"
                onClick={() => history.goBack()}
                icon={faUndo}
              >
                Volver
              </ButtonIcon>
              <ButtonIcon
                color="primary"
                className="px-5 ml-2"
                size="md"
                type="submit"
                disabled={!edited}
                icon={faSave}
              >
                Guardar
              </ButtonIcon>
            </Flex>
          </CardFooter>
        </PreloadState>
      </Card>
    </>
  );
};

export default EditeParking;
